import BaseController from '../../BaseController';
import { ApplicationRoute } from '../../../constants/routes';
import DiagnosisService from '../diagnosis-service';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import { ModalProps, ModalService } from '@philips-internal/oswald-ui-components';

import './diagnosis-menu.css';
import { generateUUID } from '@philips-internal/oswald-ui-utils';

export default class DiagnosisMenu extends BaseController {

  diagnosisService = new DiagnosisService(this);

  onDelete(): void {
    const encounterId = this.context.get('encounterId') as number;
    const patientId = this.context.get('patientId') as number;
    const sequenceNumber = this.context.get('sequenceNumber') as string;
    const diagnosisService = new DiagnosisService(this);

    diagnosisService.confirmDelete(patientId, encounterId, parseInt(sequenceNumber));
  }

  onInactivate(): void {

    const encounterId = this.context.get('encounterId') as number;
    const patientId = this.context.get('patientId') as number;
    const sequenceNumber = this.context.get('sequenceNumber') as string;

    const dialogModal: ModalProps = {
      closeable: false,
      closeByDocument: false,
      closeByEscape: false,
      focusOnOpen: false,
      fragment: 'diagnosis-inactivation',
      onCancel: () => { },
      onSubmit: () => { },
      title: 'title.disable-record',
      uuid: generateUUID(),
    };

    dialogModal.contextData = {
      encounterId,
      patientId,
      sequenceNumber
    }
    ModalService.openDefault(dialogModal);
  }

  onNew(): void {
    applicationContext.redirect(ApplicationRoute.DIAGNOSIS_CREATE);
  }
}
